export default __webpack_public_path__ + "static/media/creditcards.2ae053e1.png";